function TestInstructions({ test }) {
  if (!test) return null;

  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Instructions</h3>
      <p>
        Make sure to understand the instructions for each type before attempting the test. 
      </p>
      <p>
        <strong>Single choice:</strong> Select one correct answer.
      </p>
      <p>
        <strong>Multi select:</strong> Select multiple correct answers. Question text will specify how many answers to select.  
      </p>
    </div>
  );
}

export default TestInstructions;
